import { message } from "antd";
import { IManager } from "../services/Manager";
import getFileNameFromContentDisposition from "../helpers/parsers";
import downloadFile from "../helpers/downloadFile";

export default function downloadCmrPdf(apiManager: IManager, id: number): void {
  apiManager
    .downloadCmrsPdf(id)
    .then((response) => {
      const fileName = getFileNameFromContentDisposition(
        response.headers.get("Content-Disposition")
      );

      response.blob().then((blob) => {
        downloadFile(blob, fileName);
      });
    })
    .catch(async (response) => {
      const data = await response.json();
      message.error(data.message);
    });
}
